import { useEffect } from 'react';
import pclnExperimentation from '@pcln/experimentation';
const HandleSetiActions = ({
  setiValues = []
}) => {
  useEffect(() => {
    if (setiValues === null || setiValues === void 0 ? void 0 : setiValues.length) {
      setiValues.forEach(seti => {
        pclnExperimentation.fireImpression(seti);
      });
    }
  }, []);
  return null;
};
export default HandleSetiActions;